import { render, staticRenderFns } from "./airRegionList.vue?vue&type=template&id=5d7b8c0e&scoped=true&"
import script from "./airRegionList.vue?vue&type=script&lang=js&"
export * from "./airRegionList.vue?vue&type=script&lang=js&"
import style0 from "./airRegionList.vue?vue&type=style&index=0&id=5d7b8c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b8c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7b8c0e')) {
      api.createRecord('5d7b8c0e', component.options)
    } else {
      api.reload('5d7b8c0e', component.options)
    }
    module.hot.accept("./airRegionList.vue?vue&type=template&id=5d7b8c0e&scoped=true&", function () {
      api.rerender('5d7b8c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airConfig/tabs/airRegionList.vue"
export default component.exports